var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.998,
    viewBox: "0 0 20 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34481",
    "data-name": "Path 34481",
    d: "M104.046,33.613a.454.454,0,0,0-.368.722l7.405,10.138v5.416h0a.454.454,0,0,0,.171.355l4.1,3.269a.455.455,0,0,0,.739-.355V44.472L123.5,34.335h0a.454.454,0,0,0-.368-.722Z",
    transform: "translate(-103.591 -33.613)",
    fill: "#fafcff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.429457af169e2120ce7a395317e30ea5.svg";
export { ForwardRef as ReactComponent };